"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _InputModule = _interopRequireDefault(require("./Input.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function GhostInput(_ref) {
  var disabled = _ref.disabled,
      size = _ref.size,
      type = _ref.type,
      placeholder = _ref.placeholder,
      message = _ref.message,
      value = _ref.value,
      validation = _ref.validation,
      appendAfter = _ref.appendAfter,
      innerRef = _ref.innerRef,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      responsive = _ref.responsive,
      onClearClick = _ref.onClearClick,
      attributes = _objectWithoutProperties(_ref, ["disabled", "size", "type", "placeholder", "message", "value", "validation", "appendAfter", "innerRef", "onChange", "onFocus", "onBlur", "responsive", "onClearClick"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      currentWidth = _useState4[0],
      setCurrentWidth = _useState4[1];

  var inputRef = (0, _react.useRef)(null);
  var checkWidthRef = (0, _react.useRef)(null);
  var handleFocus = (0, _react.useCallback)(function (e) {
    setFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  }, [focused, onFocus]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    setFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  }, [focused, onBlur]);
  var handleClearClick = (0, _react.useCallback)(function (e) {
    inputRef.current.focus();

    if (onClearClick) {
      onClearClick(e);
    }
  }, [inputRef, onClearClick]);
  var handleRef = (0, _react.useCallback)(function (node) {
    if (innerRef) {
      innerRef.current = node;
    }

    inputRef.current = node;
  }, [inputRef, innerRef]);
  (0, _react.useEffect)(function () {
    if (!checkWidthRef.current || !checkWidthRef.current.getBoundingClientRect().width) return;
    setCurrentWidth(checkWidthRef.current.getBoundingClientRect().width);
  }, [value]);
  var classes = (0, _classnames.default)(_InputModule.default.ghostInputBlock, disabled && _InputModule.default.disabled, appendAfter && _InputModule.default.appended, size === "sm" && _InputModule.default.sm || size === "lg" && _InputModule.default.lg, validation === "success" && _InputModule.default.success || validation === "warning" && _InputModule.default.warning || validation === "error" && _InputModule.default.error, focused && "focused" && _InputModule.default.focused, value && _InputModule.default.nonEmpty);
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("div", {
    className: _InputModule.default.ghostInputContainer
  }, _react.default.createElement("span", {
    ref: checkWidthRef,
    className: _InputModule.default.ghostWidth
  }, value), _react.default.createElement("input", _extends({
    className: (0, _classnames.default)(_InputModule.default.ghostInput, type === "file" && "file-input"),
    type: type,
    placeholder: placeholder,
    ref: handleRef,
    style: {
      width: currentWidth + 60
    },
    size: size,
    value: value,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: onChange
  }, attributes)), appendAfter, value && !appendAfter && _react.default.createElement("div", {
    className: _InputModule.default.clearButton,
    onClick: handleClearClick
  }, _react.default.createElement("i", {
    className: "icon-close"
  }))), message && validation && !disabled && _react.default.createElement("div", {
    className: _InputModule.default.validationMessage
  }, message));
}

GhostInput.propTypes = {
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  validation: _propTypes.default.bool,
  message: _propTypes.default.string,
  size: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.string.isRequired,
  appendAfter: _propTypes.default.node,
  onClearClick: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
};
GhostInput.defaultProps = {
  disabled: false,
  label: "",
  placeholder: "",
  validation: "",
  message: "",
  size: "",
  type: "text",
  appendAfter: null
};
var _default = GhostInput;
exports.default = _default;